import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import api from "../api/axios"; // your configured axios instance
import "../styles/ProductSection.css";

// 🔹 Product Card
const ProductCard = ({ product }) => {
  return (
    <a
      href={product.link}
      className="product-card"
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="product-image-wrapper">
        <img
          src={product.image}
          alt={product.name}
          loading="lazy"
        />
      </div>
      <h6>{product.name}</h6>
    </a>
  );
};

// 🔹 Product Section with Slider
const ProductSection = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get("companyblog/products/");
        setProducts(res.data.data);
      } catch (error) {
        console.error("Failed to fetch products", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  if (loading) {
    return (
      <section className="product-section">
        <p style={{ textAlign: "center" }}>Loading products...</p>
      </section>
    );
  }

  if (!products.length) {
    return null;
  }

  return (
    <section className="product-section" id="products">
      <div className="section-title-five">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="content">
                <h6>Our Products</h6>
                <h2 className="fw-bold">What Can We Provide ?</h2>
                <p>
                  Our products are built to solve practical problems and provide long-lasting value for our customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Swiper
        modules={[Navigation, Pagination]}
        spaceBetween={20}
        slidesPerView={3}
        navigation
        pagination={{ clickable: true }}
        breakpoints={{
          320: { slidesPerView: 1 },
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {products.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard product={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default ProductSection;
